export default "__VITE_ASSET__658a1391__"